// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SegmentVertical-module__wrapper___4LUy9","removeWrapper":"SegmentVertical-module__removeWrapper___Lmosl","remove":"SegmentVertical-module__remove___dREyJ"};